export default __webpack_public_path__ + "static/media/iACST_Hero.1568bffc.png";